import { useSupabase } from '../contexts/SupabaseContext'
import { signUp, signIn, signOut } from '../services/supabase'
import toast from 'react-hot-toast'

export const useAuth = () => {
  const { user, profile, loading, isAuthenticated, supabase } = useSupabase()

  const login = async (email, password) => {
    try {
      const { data, error } = await signIn(email, password)
      
      if (error) {
        toast.error(error.message || 'Login failed')
        return { success: false, error }
      }
      
      toast.success('Welcome back!')
      return { success: true, data }
    } catch (error) {
      toast.error('Login failed')
      return { success: false, error }
    }
  }

  const register = async (email, password, username) => {
    try {
      const { data, error } = await signUp(email, password, username)
      
      if (error) {
        toast.error(error.message || 'Registration failed')
        return { success: false, error }
      }
      
      toast.success('Account created successfully!')
      return { success: true, data }
    } catch (error) {
      toast.error('Registration failed')
      return { success: false, error }
    }
  }

  const logout = async () => {
    try {
      const { error } = await signOut()
      
      if (error) {
        toast.error(error.message || 'Logout failed')
        return { success: false, error }
      }
      
      toast.success('Logged out successfully')
      return { success: true }
    } catch (error) {
      toast.error('Logout failed')
      return { success: false, error }
    }
  }

  const requireAuth = (callback) => {
    if (!isAuthenticated) {
      toast.error('Please login to continue')
      return false
    }
    
    if (typeof callback === 'function') {
      callback()
    }
    
    return true
  }

  const isAdmin = () => {
    return profile?.role === 'admin'
  }

  const requireAdmin = (callback) => {
    if (!isAuthenticated) {
      toast.error('Please login to continue')
      return false
    }
    
    if (!isAdmin()) {
      toast.error('Admin access required')
      return false
    }
    
    if (typeof callback === 'function') {
      callback()
    }
    
    return true
  }

  return {
    user,
    profile,
    loading,
    isAuthenticated,
    login,
    register,
    logout,
    requireAuth,
    requireAdmin,
    isAdmin,
    supabase
  }
}
